<div class="filter-container">
  <div class="header">
    <h3>{{"BREADCRUMB.STATISTICS" | translate}}</h3>
  </div>

  <div class="form">
    <div class="spinner" *ngIf="isExportingPdfInProgress">
      <app-spinner></app-spinner>
    </div>

    <ng-container [formGroup]="form">
      <app-date-range formControlName="date"></app-date-range>
      <app-tree-dropdown [dropdownConfigurations]="categoriesDropdownConfigs" [caller]="fetchCategories()"></app-tree-dropdown>
      <button (click)="onExportPdf()" [disabled]="!isPdfReady" class="export">
        <app-spinner *ngIf="!isPdfReady" class="spinner-btn" [size]="SpinnerSize.ULTRA_SMALL"></app-spinner>
        {{"BUTTONS.EXPORT_PDF" | translate}}
      </button>
    </ng-container>
    <div class="buttons">
      <button (click)="onSearch()"><mat-icon>search</mat-icon></button>
      <button [disabled]="!disableSearch  || (form.value | isObjectHasValues)" (click)="onReset(resetFilterValue)"><mat-icon>close</mat-icon></button>
    </div>
  </div>
</div>
